module.exports = __webpack_public_path__ + "static/media/drum4.bb231944.ogg";